const readableNumFormat = value =>
  !value && value !== 0
    ? ""
    : value
        .toString()
        .replace(/(\s|[^0-9$.])/g, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

export default readableNumFormat;
